<div class="grid-toolbar">
  <div class="toolbar-items">
    @if (doRefresh()) {
      <button type="button" class="toolbar-btn" (click)="refreshClick.emit()">
        <i class="ph ph-arrow-clockwise"></i>
        <span>{{ 'refresh' | translate }}</span>
      </button>
    }
    @for (a of customToolbar(); track a.slug) {
      @if (!a.separator) {
        <button
          type="button"
          class="toolbar-btn"
          [disabled]="a.disabled || (!a.gridLevel && (disabledButton() || recordFetchLoading()))"
          (click)="customToolbarActionClick.emit(a)">
          <i [class]="a.icon || ''"></i>
          <span>{{ a.slug_2 ?? a.slug | translate }}</span>
        </button>
      }
    }
    @if (filterable()) {
      <div class="toolbar-btn-group">
        <button type="button" class="toolbar-btn" (click)="toggleFilterClick.emit()">
          <i class="ph ph-funnel"></i>
          <span>{{ 'filter' | translate }}</span>
        </button>
        @if (customFilter()) {
          <button type="button" class="toolbar-btn toolbar-btn--dropdown" (click)="filterMenu.toggle($event)">
            <i class="ph ph-caret-down"></i>
          </button>
          <p-menu #filterMenu [model]="filterMenuModel()" [popup]="true" [appendTo]="menuAppendTo()" />
        }
      </div>
    }
    @if (doExport()) {
      <button type="button" class="toolbar-btn" [disabled]="disabledButton()" (click)="exportClick.emit('XLSX')">
        <i class="ph ph-file-xls"></i>
        <span>{{ 'export' | translate }}</span>
      </button>
    }
    @if (fullscreenEnabled()) {
      <button type="button" class="toolbar-btn" (click)="toggleFullscreenClick.emit()">
        <i [class]="fullscreenActive() ? 'ph ph-corners-in' : 'ph ph-corners-out'"></i>
        <span>{{ (fullscreenActive() ? 'exit_fullscreen' : 'fullscreen') | translate }}</span>
      </button>
    }
    @if (hasOtherMenu()) {
      <div class="toolbar-btn-group">
        <button type="button" class="toolbar-btn" [disabled]="disabledButton()" (click)="otherMenu.toggle($event)">
          <i class="ph ph-list"></i>
          <span>{{ 'other' | translate }}</span>
          <i class="ph ph-caret-down toolbar-btn-chevron"></i>
        </button>
        <p-menu #otherMenu [model]="otherMenuModel()" [popup]="true" [appendTo]="menuAppendTo()" />
      </div>
    }
  </div>
</div>
